import addReport from './add-report';

const addReportActions = { ...addReport };

export default addReportActions;
